export default __webpack_public_path__ + "static/media/nimLi1.4e823760.webp";